import api from './client'

export const biApi = {
  // indexes:null → arrays como `rubro[]=a&rubro[]=b` (Laravel los lee como array)
  ventas: (params) => api.get('/bi/ventas', { params, paramsSerializer: { indexes: null } }),
  dimensiones: () => api.get('/bi/ventas/dimensiones'),
  gastos: (params) => api.get('/bi/gastos', { params, paramsSerializer: { indexes: null } }),
  gastosDimensiones: () => api.get('/bi/gastos/dimensiones'),
  cubo: (params) => api.get('/bi/ventas/cubo', { params, paramsSerializer: { indexes: null } }),
  cuboOpciones: () => api.get('/bi/ventas/cubo/opciones'),
  // Cubo estilo Presea (BI → Cubo): período primero, renglones crudos, vistas por persona
  cuboRango: () => api.get('/bi/cubo/rango'),
  cuboLineas: (params) => api.get('/bi/cubo/lineas', { params }),
  cuboVistas: () => api.get('/bi/cubo/vistas'),
  cuboGuardarVista: (data) => api.post('/bi/cubo/vistas', data),
  cuboBorrarVista: (id) => api.delete(`/bi/cubo/vistas/${id}`),
  informe: (slug = 'ventas-ligier') => api.get(`/bi/informe/${slug}`),
  // BI → Reportes: reportes fijos con fechas variables (compu y celular)
  reportes: () => api.get('/bi/reportes'),
  reporte: (clave, params) => api.get(`/bi/reportes/${clave}`, { params }),
  // Tablero de Dirección (motor de hallazgos + pulso)
  pulso: () => api.get('/bi/pulso'),
  hallazgos: (params) => api.get('/bi/hallazgos', { params }),
  hallazgoVisto: (id) => api.post(`/bi/hallazgos/${id}/visto`),
  hallazgoDescartar: (id) => api.post(`/bi/hallazgos/${id}/descartar`),
}
